import { marginPaddingParser } from '../../../../utils/style';
var marginPadding = function (_a) {
    var margin = _a.margin, padding = _a.padding, measure = _a.measure;
    return "\n  ".concat(margin ? "margin: ".concat(marginPaddingParser(margin, measure), ";") : '', "\n  ").concat(padding ? "padding: ".concat(marginPaddingParser(padding, measure), ";") : '', "\n");
};
export default marginPadding;
